import { Environment } from './Environment';
import { RootStore } from './RootStore';

export const createAppStore = () => RootStore.create({}, new Environment());
